var k_r_submitter=/^(?:submit|button|image|reset|file)$/i;var k_r_success_contrls=/^(?:input|select|textarea|keygen)/i;var brackets=/(\[[^\[\]]*\])/g;function serialize(form,options){if(typeof options!='object'){options={hash:!!options}}else if(options.hash===undefined){options.hash=!0}
  var result=(options.hash)?{}:'';var serializer=options.serializer||((options.hash)?hash_serializer:str_serialize);var elements=form&&form.elements?form.elements:[];var radio_store=Object.create(null);for(var i=0;i<elements.length;++i){var element=elements[i];if((!options.disabled&&element.disabled)||!element.name){continue}
    if(!k_r_success_contrls.test(element.nodeName)||k_r_submitter.test(element.type)){continue}
    var key=element.name;var val=element.value;if((element.type==='checkbox'||element.type==='radio')&&!element.checked){val=undefined}
    if(options.empty){if(element.type==='checkbox'&&!element.checked){val=''}
      if(element.type==='radio'){if(!radio_store[element.name]&&!element.checked){radio_store[element.name]=!1}else if(element.checked){radio_store[element.name]=!0}}
      if(val==undefined&&element.type=='radio'){continue}}else{if(!val){continue}}
    if(element.type==='select-multiple'){val=[];var selectOptions=element.options;var isSelectedOptions=!1;for(var j=0;j<selectOptions.length;++j){var option=selectOptions[j];var allowedEmpty=options.empty&&!option.value;var hasValue=(option.value||allowedEmpty);if(option.selected&&hasValue){isSelectedOptions=!0;if(options.hash&&key.slice(key.length-2)!=='[]'){result=serializer(result,key+'[]',option.value)}else{result=serializer(result,key,option.value)}}}
      if(!isSelectedOptions&&options.empty){result=serializer(result,key,'')}
      continue}
    result=serializer(result,key,val)}
  if(options.empty){for(var key in radio_store){if(!radio_store[key]){result=serializer(result,key,'')}}}
  return result}
function parse_keys(string){var keys=[];var prefix=/^([^\[\]]*)/;var children=new RegExp(brackets);var match=prefix.exec(string);if(match[1]){keys.push(match[1])}
  while((match=children.exec(string))!==null){keys.push(match[1])}
  return keys}
function hash_assign(result,keys,value){if(keys.length===0){result=value;return result}
  var key=keys.shift();var between=key.match(/^\[(.+?)\]$/);if(key==='[]'){result=result||[];if(Array.isArray(result)){result.push(hash_assign(null,keys,value))}else{result._values=result._values||[];result._values.push(hash_assign(null,keys,value))}
    return result}
  if(!between){result[key]=hash_assign(result[key],keys,value)}else{var string=between[1];var index=+string;if(isNaN(index)){result=result||{};result[string]=hash_assign(result[string],keys,value)}else{result=result||[];result[index]=hash_assign(result[index],keys,value)}}
  return result}
function hash_serializer(result,key,value){var matches=key.match(brackets);if(matches){var keys=parse_keys(key);hash_assign(result,keys,value)}else{var existing=result[key];if(existing){if(!Array.isArray(existing)){result[key]=[existing]}
  result[key].push(value)}else{result[key]=value}}
  return result}
function str_serialize(result,key,value){value=value.replace(/(\r)?\n/g,'\r\n');value=encodeURIComponent(value);value=value.replace(/%20/g,'+');return result+(result?'&':'')+encodeURIComponent(key)+'='+value}

class CartDrawer {
  constructor() {
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.atcButtons = document.querySelectorAll('[data-product-atc]');
    this.optionSelects = document.querySelectorAll('[data-product-select]');
    this.cartCount = document.querySelector('[data-header-cart-count]');
    this.cartSection = document.getElementById('shopify-section-cart-body');
    this.drawerOpenButton = document.querySelector('[data-cart-drawer-open]');
    this.drawerCloseButton = document.querySelector('[data-cart-drawer-close]');
    const formContainer = document.querySelector(".product-form[data-product]");
    this.productData = formContainer ? JSON.parse(formContainer.dataset.product) : {};

    this.trigger = null;

    if (this.atcButtons) {
      this.atcButtons.forEach(button => {
        button.addEventListener( 'click', e => {
          e.preventDefault();
          this.trigger = button;
          this.addItem(button);
        });
      });
    }

    if(this.optionSelects) {
      this.optionSelects.forEach(select => {
        select.addEventListener("change", e => {
          e.preventDefault();
          const productHandle = e.target.options[e.target.selectedIndex].dataset.productHandle;
          window.location.href = `/products/${productHandle}`;
        });
      });
    }

    this._closeEsc = e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.closeDrawer();
      }
    };

    this.loadDrawer();
  }

  updateCartCount(itemCount) {
    this.cartCount.innerHTML = itemCount;
  }

  addItem(button) {
    const atcButton = button;
    const buttonForm = button.form;
    const formData = serialize(buttonForm, {
      hash: true
    });
    atcButton.classList.add('parent');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => response.json()).then(() => {
      this.loadDrawer(true, atcButton);
    });
  }

  removeItem(line) {
    this.cartSection.classList.add("opacity-50");
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: 0,
        line
      })
    }).then(response => response.json()).then(() => {
      this.loadDrawer();
    });
  }

  updateItem(line, quantity) {
    this.cartSection.classList.add("opacity-50");
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity,
        line
      })
    }).then(response => response.json()).then(() => {
      this.loadDrawer();
    });
  }

  async loadDrawer(forceOpen = false, atcButton = '') {
    const response = await Promise.all([
      fetch('/cart?sections=cart-body'),
      fetch('/cart.js'),
    ]);
    const result = await Promise.all([
      response[0].json(),
      response[1].json()
    ]);
    this.cartSection.outerHTML = result[0]['cart-body'];
    this.initDrawer(forceOpen);
    if (atcButton !== '') {
      atcButton.classList.remove('parent');
    }
    this.updateCartCount(result[1].item_count);
  }

  initDrawer(forceOpen) {
    this.cartSection = document.getElementById('shopify-section-cart-body');
    this.inputFields = this.drawer.querySelectorAll('[data-quantity-input]');
    this.removeButtons = this.drawer.querySelectorAll('[data-remove-item]');
    this.inputFields.forEach(input => {
      input.parentNode.querySelector('[data-quantity-minus]').addEventListener('click', (e) => {
        e.preventDefault();
        const lineID = input.dataset.lineId;
        const quantity = input.value;
        this.updateItem(lineID, parseInt(quantity) - 1);
      });
      input.parentNode.querySelector('[data-quantity-plus]').addEventListener('click', (e) => {
        e.preventDefault();
        const lineID = input.dataset.lineId;
        const quantity = input.value;
        this.updateItem(lineID, parseInt(quantity) + 1);
      });
      input.addEventListener("change", () => {
        const lineID = input.dataset.lineId;
        const quantity = input.value;
        this.updateItem(lineID, quantity);
      });
    });
    this.removeButtons.forEach(button => {
      button.addEventListener( 'click', e => {
        e.preventDefault();
        this.removeItem(button.dataset.removeItem);
      });
    });
    this.drawerOpenButton.addEventListener('click', e => {
      e.preventDefault();
      this.openDrawer();
      this.trigger = this.drawerOpenButton;
    });
    this.drawerCloseButton.addEventListener( 'click', e => {
      e.preventDefault();
      this.closeDrawer();
    });
    this.overlay.addEventListener( 'click', e => {
      if (e.target.classList.contains('cart--opened')) {
        this.closeDrawer();
      }
    });

    if (forceOpen === true) {
      this.openDrawer();
    }
  }

  openDrawer() {
    //stagger to allow animation
    this.overlay.classList.remove('hidden');
    setTimeout( () => {
      this.overlay.classList.add('cart--opened');
    }, 10);
    window.addEventListener('keydown', this._closeEsc, false);
  }

  closeDrawer() {
    //stagger to allow animation
    this.overlay.classList.remove('cart--opened');
    setTimeout( () => {
      this.overlay.classList.add('hidden');
    }, 250);
    window.removeEventListener('keydown', this._closeEsc, false);
  }
}

new CartDrawer();
